import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Video, VideosResult } from '../interfaces';
import { AuthService } from '../../services/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class VideosDataService {

  private uri: string = `${environment.apiUrl}list-video`;
  private headers:any ;

  constructor(
    private http: HttpClient
  ) {
    const jsonAuth = localStorage.getItem(AuthService.ATUH_STORAGE_KEY);
    if (jsonAuth) {
      const token = JSON.parse(jsonAuth)?.token;
      if (token) {
        this.headers = new HttpHeaders({

          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin':'*',
          enctype: 'multipart/form-data',
          authorization: 'Bearer ' + token,
        });
      } 
    }
  }

  getVideos(): Observable<VideosResult|any> {
    return this.http.get(this.uri + "/all-videos");
  }

  addVideo(data: any): Observable<Video|any> {
    return this.http.post(this.uri + '/add', data);
  }

  updateVideo(data: any,id:any): Observable<Video|any> {
    return this.http.post(this.uri + '/update'+ `/${id}`, data);
  }

  deleteVideo(data: Video): Observable<null|any> {
    return this.http.put(this.uri + "/update_active" + `/${data.id}`, "");
  }

}
